import { _ } from "libs";
import React from "react";
import { Profile, Sport } from "../../types";

type Props = {
	profile: Profile;
	sports: Sport[];
	onChange: Function;
};

export function SportSelector({ profile, sports, onChange }: Props) {
	const handleChange = (sport: Sport) => {
		onChange({ sport: sport.name });
	};

	return (
		<div className="buttonList">
			{sports
				.filter(sport => sport.label !== "label.other")
				.map(sport => {
					const className = sport.name === profile.sport ? "selected" : null;
					return (
						<a key={sport.name} onClick={handleChange.bind(this, sport)} className={className}>
							{_(sport.label)}
						</a>
					);
				})}
		</div>
	);
}

export default SportSelector;
